import celebration from '../../assets/celebration.png'
import { AppDownloadButtons } from '../../shared-components/AppDownloadButtons'
import { useScreenTracking } from '../../shared-hooks/useScreenTracking'
import { SignupCard } from './SignupCard'

type FinishedProps = {
  totalGuarantee: number
}

export const Finished = ({ totalGuarantee }: FinishedProps): JSX.Element => {
  useScreenTracking('FinishedView', 'View finished screen')

  return (
    <SignupCard
      iconSrc={celebration}
      heading={`We're now protecting $${totalGuarantee.toFixed(2)}!`}
      subheading='Congrats on starting your 1 week free trial with Belay! This schedule will be recurring, and to edit, add or remove hours, download the Belay app below.'
    >
      <AppDownloadButtons />
    </SignupCard>
  )
}
